import type { ChatbotFeedbackCheckboxOption } from 'src/types/chatbot';

export const chatbotMultiSelectOptions: ChatbotFeedbackCheckboxOption[] = [
  {
    label: 'ChatbotFeedback.MultiSelect.TooShort',
    name: 'answer_too_short',
  },
  {
    label: 'ChatbotFeedback.MultiSelect.TooLong',
    name: 'answer_too_long',
  },
  {
    label: 'ChatbotFeedback.MultiSelect.Incomplete',
    name: 'answer_seems_incomplete',
  },
  {
    label: 'ChatbotFeedback.MultiSelect.Inappropriate',
    name: 'answer_inappropriate',
  },
  {
    label: 'ChatbotFeedback.MultiSelect.PartiallyWrong',
    name: 'answer_has_wrong_info',
  },
  {
    label: 'ChatbotFeedback.MultiSelect.NotHelpful',
    name: 'answer_not_helpful',
  },
];
